import { CheckBoxComponentValue } from "../types";

/**
 * Třístavový přepínač
 * Více informací o přepínání v `CheckBoxSwitcher.md`.
 * @param value Hodnota před přepnutím
 * @return Hodnotu po přepnutí
 */
export const getNextCheckBoxValue = (value: CheckBoxComponentValue): CheckBoxComponentValue => {
    switch (value) {
        case true:
            return false;
        case false:
            return undefined;
        case undefined:
            return true;
        default: throw new Error(`[CheckBoxComponent] - Unexpected value ${value}`);
    }
};
